/*
 * Rezept-Widget für kaffee-online-kaufen.com
 * Wird einmalig im Theme geladen und steuert alle .rw Widgets
 * auf Blog-Artikeln via Event-Delegation.
 *
 * Install: assets/rezept-widget.js
 * Einbindung in layout/theme.liquid kurz vor </body>:
 *   <script src="{{ 'rezept-widget.js' | asset_url }}" defer></script>
 */
(function () {
  'use strict';

  // Helper: rundet sinnvoll (ganze Zahl wenn möglich, sonst eine Dezimalstelle)
  function fmt(v) {
    if (v === 0) return '';
    var r = Math.round(v * 10) / 10;
    return r === Math.round(r) ? String(Math.round(r)) : String(r);
  }

  // Alle Zutatenmengen eines Widgets auf aktuelle Portionszahl skalieren
  function updatePortions(widget) {
    var countEl = widget.querySelector('.rw-count');
    var list = widget.querySelector('.rw-ings');
    if (!countEl || !list) return;

    var current = parseInt(countEl.textContent, 10) || 2;
    var base = parseInt(list.getAttribute('data-base'), 10) || 2;
    var factor = current / base;

    widget.querySelectorAll('.rw-ing').forEach(function (li) {
      var amount = parseFloat(li.getAttribute('data-amount')) || 0;
      var unit = li.getAttribute('data-unit') || '';
      var name = li.getAttribute('data-name') || '';
      var textEl = li.querySelector('.rw-ing-t');
      if (!textEl) return;
      textEl.textContent = amount > 0
        ? fmt(amount * factor) + (unit ? ' ' + unit : '') + ' ' + name
        : name;
    });
  }

  // Wake-Lock Verwaltung (Bildschirm wach halten beim Kochen)
  var wakeLocks = new WeakMap();

  function showUnavailable(txtEl) {
    if (!txtEl) return;
    txtEl.textContent = 'Nicht verf\u00fcgbar';
    setTimeout(function () {
      txtEl.textContent = 'Bildschirm bleibt an';
    }, 2000);
  }

  function toggleWakeLock(btn) {
    var txtEl = btn.querySelector('.rw-wl-txt');
    var existing = wakeLocks.get(btn);

    if (existing) {
      if (existing.release) existing.release();
      wakeLocks.delete(btn);
      btn.classList.remove('on');
      if (txtEl) txtEl.textContent = 'Bildschirm bleibt an';
      return;
    }

    if (!('wakeLock' in navigator)) {
      showUnavailable(txtEl);
      return;
    }

    navigator.wakeLock.request('screen').then(function (lock) {
      wakeLocks.set(btn, lock);
      btn.classList.add('on');
      if (txtEl) txtEl.textContent = 'Bildschirm bleibt an \u2713';
      lock.addEventListener('release', function () {
        wakeLocks.delete(btn);
        btn.classList.remove('on');
        if (txtEl) txtEl.textContent = 'Bildschirm bleibt an';
      });
    }).catch(function () {
      showUnavailable(txtEl);
    });
  }

  // Event-Delegation auf document – funktioniert auch für dynamisch eingefügte Widgets
  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-rw-action]');
    if (!el) return;

    var widget = el.closest('.rw');
    if (!widget) return;

    var action = el.getAttribute('data-rw-action');

    if (action === 'portions-minus' || action === 'portions-plus') {
      var countEl = widget.querySelector('.rw-count');
      if (!countEl) return;
      var current = parseInt(countEl.textContent, 10) || 2;

      if (action === 'portions-minus') {
        if (current <= 1) return;
        countEl.textContent = current - 1;
      } else {
        if (current >= 20) return;
        countEl.textContent = current + 1;
      }
      updatePortions(widget);
      return;
    }

    if (action === 'toggle-ingredient') {
      el.classList.toggle('done');
      var cb = el.querySelector('input[type=checkbox]');
      if (cb) cb.checked = el.classList.contains('done');
      return;
    }

    if (action === 'toggle-wakelock') {
      toggleWakeLock(el);
      return;
    }
  });
})();